module.exports = {
	"description": "MenuGroups group together [Menu Items](./menu-items) and can display a title.",
	"methods": [],
	"props": {
		"children": {
			"flowType": {
				"name": "MnrlReactNode"
			},
			"required": false,
			"description": "[MenuItems](./menu-item)"
		},
		"title": {
			"flowType": {
				"name": "MnrlReactNode"
			},
			"required": false,
			"description": "Title for the group"
		}
	}
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-docgen-loader!./src/Menu/MenuGroup.js
// module id = 1627
// module chunks = 0